export interface ModbusFunctionType {
  name: string;
  code: number;
  functionWrites: boolean;
  pointIsWritable: boolean;
}

export const MODBUS_FUNC_READ_COILS: ModbusFunctionType = {
  name: 'Read Coils',
  code: 1,
  functionWrites: false,
  pointIsWritable: true,
};

export const MODBUS_FUNC_READ_DISCRETE_INPUTS: ModbusFunctionType = {
  name: 'Read Discrete Inputs',
  code: 2,
  functionWrites: false,
  pointIsWritable: false,
};

export const MODBUS_FUNC_READ_MULTIPLE_HOLDING_REGISTERS: ModbusFunctionType = {
  name: 'Read Multiple Holding Registers',
  code: 3,
  functionWrites: false,
  pointIsWritable: true,
};

export const MODBUS_FUNC_READ_INPUT_REGISTERS: ModbusFunctionType = {
  name: 'Read Input Registers',
  code: 4,
  functionWrites: false,
  pointIsWritable: false,
};

export const MODBUS_FUNC_WRITE_SINGLE_COIL: ModbusFunctionType = {
  name: 'Write Single Coil',
  code: 5,
  functionWrites: true,
  pointIsWritable: true,
};

export const MODBUS_FUNC_WRITE_SINGLE_HOLDING_REGISTER: ModbusFunctionType = {
  name: 'Write Single Holding Register',
  code: 6,
  functionWrites: true,
  pointIsWritable: true,
};
